import axios from "axios";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { useLocation, useNavigate } from "react-router-dom";
import UnavailableSlotPopup from "../../Common/Model/UnavailableSlotPopup";
import useSticky from "../../Utility/useSticky";
import Success from "../Modal/Success";

function ScheduleLocation({ experienceId, onSuccess, onBack }) {
  const token = localStorage.getItem("authToken");
  const navigate = useNavigate();
  const location = useLocation();
  const isOtherExperience = location.state?.isOtherExperience;
  const isEdit = location.state?.isEdit;
  const updateexperienceId = location.state?.experienceId;
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loadingSubmit, setloadingSubmit] = useState(false);
  const [completedPackages, setCompletedPackages] = useState([]);
  const [allowedDays, setAllowedDays] = useState([]);

  const [noOfGuest, setNoOfGuest] = useState("");


  // Package Slot
  const [packages, setPackages] = useState([]);
  const [activeIndex, setActiveIndex] = useState(0);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");

  const isSticky = useSticky("sticy_fixedss2", 130);
  // Slots per day
  const [slots, setSlots] = useState({
    1: [],
    2: [],
    3: [],
    4: [],
    5: [],
    6: [],
    0: [],
  });

  const [newSlot, setNewSlot] = useState({
    slot_day: "",
    duration: 60,
    from_time: "",
    to_time: "",
    no_of_pax: "",
  });

  // Temp slot being added
  const [selectedDays, setSelectedDays] = useState([]);

  const [unavailableSlots, setUnavailableSlots] = useState([
    { date: "", from_time: "", to_time: "" },
  ]);

  const fetchHostSlots = async (pkgId) => {
    try {
      const expId = experienceId || updateexperienceId;
      // if (!experienceId) return;

      const res = await axios.get(
        `${process.env.REACT_APP_API_BASE}/host/get-host-slots/${expId}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (res.data?.status && Array.isArray(res.data.data)) {
        // ✅ Filter by selected package_id (if provided)

        const filteredSlots = pkgId
          ? res.data.data.filter((slot) => slot.package_id === pkgId)
          : res.data.data;

          // ✅ If a package is selected, auto-set No. of Pax
      if (pkgId && filteredSlots.length > 0) {
        setNoOfGuest(filteredSlots[0].no_of_pax || ""); // 👈 Auto-fill pax
        
        // Sync newSlot.duration with the duration of the first slot
        const fetchedDuration = filteredSlots[0].duration;
        if (fetchedDuration) {
          setNewSlot((prev) => ({ ...prev, duration: fetchedDuration }));
        }
      } else {
        setNoOfGuest(""); // reset if no slot found
      }


        // ✅ Group by day (1–7)
        const grouped = { 1: [], 2: [], 3: [], 4: [], 5: [], 6: [], 0: [] };

        filteredSlots.forEach((slot) => {
          const day = slot.slot_day;
          const fromTime = slot.from_time?.slice(0, 5) || "";
          const toTime = slot.to_time?.slice(0, 5) || "";

          if (!grouped[day]) grouped[day] = [];
          grouped[day].push({
            slot_day: slot.slot_day,
            duration: slot.duration,
            from_time: fromTime,
            to_time: toTime,
            // no_of_pax: slot.no_of_pax || "",
          });
        });

        // ✅ Update slot state
        setSlots(grouped);

        // ✅ Automatically select active days
        const selected = Object.entries(grouped)
          .filter(([_, arr]) => arr.length > 0)
          .map(([day]) => Number(day));

        setSelectedDays(selected);
      }
    } catch (err) {
      console.error("Failed to fetch slots:", err);
    }
  };

  useEffect(() => {
    if (!fromDate || !toDate) {
      setAllowedDays([]);
      return;
    }

    const start = new Date(fromDate);
    const end = new Date(toDate);
    const days = [];

    while (start <= end) {
      const dayIndex = start.getDay(); // Sunday=0, Monday=1, ...
      if (!days.includes(dayIndex)) days.push(dayIndex);
      start.setDate(start.getDate() + 1);
    }

    setAllowedDays(days);
  }, [fromDate, toDate]);

  // ✅ Toggle day selection
  // const handleDayToggle = (day) => {
  //   setSelectedDays((prev) =>
  //     prev.includes(day) ? prev.filter((d) => d !== day) : [...prev, day]
  //   );
  //   setNewSlot((s) => ({ ...s, slot_day: day }));
  // };

  const handleDayToggle = (day) => {
    setSelectedDays((prev) => {
      const isSelected = prev.includes(day);
      let updatedDays;

      if (isSelected) {
        updatedDays = prev.filter((d) => d !== day);

        // 🧹 Clear all slots for this day when it's unchecked
        setSlots((prevSlots) => {
          const updatedSlots = { ...prevSlots, [day]: [] };

          return updatedSlots;
        });

        // 🧹 Optionally clear newSlot if it belongs to that day
        setNewSlot((s) => (s.slot_day === day ? { ...s, slot_day: "" } : s));
      } else {
        updatedDays = [...prev, day];

        setNewSlot((s) => ({ ...s, slot_day: day }));

        setSlots((prevSlots) => {
          const updatedSlots = { ...prevSlots };
          if (!updatedSlots[day] || updatedSlots[day].length === 0) {
            updatedSlots[day] = [
              {
                slot_day: day,
                duration: 60,
                from_time: "",
                to_time: "",
                no_of_pax: "",
              },
            ];
          }
          return updatedSlots;
        });
      }

      return updatedDays;
    });
  };

  const handleRemoveSlot = (day, index) => {
    const updated = [...slots[day]];
    updated.splice(index, 1);
    setSlots((prev) => ({ ...prev, [day]: updated }));
  };

  // get start_time from localStorage (if any)
  const itineraryData = JSON.parse(
    localStorage.getItem("itineraryData") || "{}"
  );
  const defaultStartTime = itineraryData.start_time || ""; // e.g. "16:57"
  const [showUnavailablePopup, setShowUnavailablePopup] = useState(false);


  const handleAddSlot = (day) => {
    const newSlot = {
      slot_day: day,
      duration: 60,
      from_time: "",
      to_time: "",
      no_of_pax: "",
    };

    setSlots((prev) => ({
      ...prev,
      [day]: [...(prev[day] || []), newSlot],
    }));
  };

  const handleSlotChange = (day, index, field, value) => {
    const updated = [...(slots[day] || [])];

    if (!updated[index]) {
      updated[index] = {
        slot_day: day,
        duration: 60,
        from_time: "",
        to_time: "",
        no_of_pax: "",
      };
    }

    updated[index][field] = value;

    // Auto-calculate to_time when from_time or duration changes
    if ((field === "from_time" || field === "duration") && updated[index].from_time && updated[index].duration) {
      updated[index].to_time = addMinutes(updated[index].from_time, updated[index].duration);
    }

    setSlots((prev) => {
      const newSlots = { ...prev, [day]: updated };
     
      return newSlots;
    });
  };

  // Add a new unavailable slot row
  const handleAddUnavailableSlot = () => {
    setUnavailableSlots((prev) => [
      ...prev,
      { date: "", from_time: "", to_time: "" },
    ]);
  };

  // Remove an unavailable slot row
  const handleRemoveUnavailableSlot = (index) => {
    setUnavailableSlots((prev) => prev.filter((_, i) => i !== index));
  };

  // Handle field change
  const handleUnavailableSlotChange = (index, field, value) => {
    setUnavailableSlots((prev) =>
      prev.map((slot, i) => (i === index ? { ...slot, [field]: value } : slot))
    );
  };

  // ✅ Validation
  const validateForm = () => {
    // 1. At least one day selected
    if (selectedDays.length === 0) {
      toast.error("Please select at least one day");
      return false;
    }

    // 2. At least one slot added for each selected day
    for (let day of selectedDays) {
      if (!slots[day] || slots[day].length === 0) {
        toast.error(`Please add at least one slot for ${dayNames[day]}`);
        return false;
      }

      for (let i = 0; i < slots[day].length; i++) {
        const slot = slots[day][i];

        // check required fields
        if (!slot.from_time || !slot.to_time || !slot.no_of_pax) {
          toast.error(
            `Please fill all slot details for ${dayNames[day]} (slot ${i + 1})`
          );
          return false;
        }

        // check no_of_pax is positive number
        if (isNaN(slot.no_of_pax) || Number(slot.no_of_pax) <= 0) {
          toast.error(
            `No. of Pax must be a positive number for ${dayNames[day]} (slot ${
              i + 1
            })`
          );
          return false;
        }

        // check to_time > from_time
        const fromDate = new Date(`1970-01-01T${slot.from_time}:00`);
        const toDate = new Date(`1970-01-01T${slot.to_time}:00`);
        if (toDate <= fromDate) {
          toast.error(
            `End time must be after start time for ${dayNames[day]} (slot ${
              i + 1
            })`
          );
          return false;
        }
      }
    }

    return true;
  };

  // ✅ Step 1: Create a dedicated validation function
  const validateUpdatePackage = (
    selectedPackage,
    fromDate,
    toDate,
    selectedDays,
    slots,
    dayNames
  ) => {
    if (!selectedPackage) {
      toast.error("Please select a package first");
      return false;
    }

    if (!fromDate || !toDate) {
      toast.error("Please select both From and To dates");
      return false;
    }

    if (fromDate === toDate) {
    toast.error("From and To dates cannot be the same");
    return false;
  }

    if (!noOfGuest || Number(noOfGuest) <= 0) {
  toast.error("Please enter a valid No. of Pax for this package");
  return false;
}


    if (selectedDays.length === 0) {
      toast.error("Please select at least one day");
      return false;
    }

    for (let day of selectedDays) {
      if (!slots[day] || slots[day].length === 0) {
        toast.error(`Please add at least one slot for ${dayNames[day]}`);
        return false;
      }

      for (let i = 0; i < slots[day].length; i++) {
        const slot = slots[day][i];

        // Verify slot duration is selected
        const selectedDuration = Number(slot.duration);
        if (!selectedDuration || isNaN(selectedDuration)) {
          toast.error(
            `Please select a duration for Slot ${i + 1} on ${dayNames[day]}`
          );
          return false;
        }

        // ✅ All fields required
        if (!slot.from_time || !slot.to_time ) {
          toast.error(
            `Please fill all fields for ${dayNames[day]} (slot ${i + 1})`
          );
          return false;
        }

        // ✅ Time validation
        const fromTime = new Date(`1970-01-01T${slot.from_time}:00`);
        const toTime = new Date(`1970-01-01T${slot.to_time}:00`);
        if (toTime <= fromTime) {
          toast.error(
            `End time must be later than start time for ${
              dayNames[day]
            } (slot ${i + 1})`
          );
          return false;
        }

        // ✅ Validate exact duration matches selected duration
        const diffInMinutes = Math.round((toTime - fromTime) / 60000);
        if (diffInMinutes !== selectedDuration) {
          const hours = selectedDuration / 60;
          const durationLabel = selectedDuration >= 60 
            ? `${hours} hr` 
            : `${selectedDuration} min`;
          toast.error(
            `Slot ${i + 1} on ${dayNames[day]} must be exactly ${durationLabel} (currently ${diffInMinutes} min)`
          );
          return false;
        }
      }

      // ✅ Check for overlapping slots on the same day
      const daySlots = slots[day];
      for (let i = 0; i < daySlots.length; i++) {
        const slotA = daySlots[i];
        const fromA = slotA.from_time;
        const toA = slotA.to_time;

        for (let j = i + 1; j < daySlots.length; j++) {
          const slotB = daySlots[j];
          const fromB = slotB.from_time;
          const toB = slotB.to_time;

          if (fromA < toB && fromB < toA) {
            toast.error(
              `Slot ${j + 1} overlaps with Slot ${i + 1} on ${dayNames[day]}. Please select a different time slot.`
            );
            return false;
          }
        }
      }
    }

    return true;
  };

  useEffect(() => {
    if (isEdit && packages.length > 0) {
      const allIds = packages.map((p) => p.id);
      setCompletedPackages(allIds);
    }
  }, [isEdit, packages]);

  const handleUpdatePackage = async () => {
    try {
      setLoading(true);

      const selectedPackage = packages[activeIndex];
      const expId = experienceId || updateexperienceId;

      const isValid = validateUpdatePackage(
        selectedPackage,
        fromDate,
        toDate,
        selectedDays,
        slots,
        dayNames
      );

      if (!isValid) {
        setLoading(false);
        return;
      }

      const formatTime = (time) =>
        time && time.length >= 5 ? time.slice(0, 5) : "";

      const slotPayload = {
        experience_id: expId,
        package_id: selectedPackage.id,
        slot_from_date: fromDate,
        slot_to_date: toDate,
        no_of_guest: Number(noOfGuest),
        slots: Object.entries(slots).flatMap(([day, arr]) =>
          arr.map((slot) => ({
            slot_day: day,
            duration: Number(slot.duration),
            from_time: formatTime(slot.from_time),
            to_time: formatTime(slot.to_time),
           
            status: 1,
          }))
        ),
      };

      

      const res = await toast.promise(
        axios.post(
          `${process.env.REACT_APP_API_BASE}/host/add-slots`,
          slotPayload,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        ),
        {
          loading: "Updating Slot...",
          success: "Slots updated successfully",
          error: "Failed to update slots",
        }
      );

      if (res.data?.status) {
       
        if (
          isEdit
          //  &&
          // unavailableSlots.some((s) => s.date && s.from_time && s.to_time)
        ) {
          const unavailablePayload = {
            experience_id: expId,
            slots: unavailableSlots
              .filter((s) => s.date && s.from_time && s.to_time)
              .map((s) => ({
                date: s.date,
                from_time: formatTime(s.from_time),
                to_time: formatTime(s.to_time),
              })),
          };

          await axios.post(
            `${process.env.REACT_APP_API_BASE}/host/save-unavailable-slots`,
            unavailablePayload,
            { headers: { Authorization: `Bearer ${token}` } }
          );

          // toast.success("Unavailable slots Update successfully");
        }

        // ✅ Mark package as completed
        setCompletedPackages((prev) => {
          if (!prev.includes(selectedPackage.id)) {
            return [...prev, selectedPackage.id];
          }
          return prev;
        });
      }
    } catch (error) {
      console.error("Error updating package:", error);
      toast.error("Something went wrong while updating");
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // 🧠 Validation: All packages must be updated first
    const allPackagesDone = packages.every((pkg) =>
      completedPackages.includes(pkg.id)
    );



    try {
      setloadingSubmit(true);

      const res = await axios.get(
        `${process.env.REACT_APP_API_BASE}/host/getuserProfile`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (res.data?.status && res.data.data) {
        const updatedUser = {
          ...res.data.data,
          signup_complete_status: res.data.data.signup_complete_status,
          user_type: res.data.data.user_type,
          base_url:
            res.data.base_url ||
            "https://admin.weyfarin.com",
        };
        localStorage.setItem("user", JSON.stringify(updatedUser));
        toast.success("Experience created successfully!");
      }

      if (isOtherExperience) {
        setShowSuccessPopup(true);
      } else {
        navigate("/listing");
      }
    } catch (error) {
      console.error("Error fetching user profile:", error);
    } finally {
      setTimeout(() => {
      setloadingSubmit(false);
      })
    }
  };

  // helper: add minutes to HH:MM and return HH:MM (24h)
  const addMinutes = (time, minsToAdd) => {
    const [h, m] = time.split(":").map(Number);
    const date = new Date();
    date.setHours(h, m + Number(minsToAdd));
    const hh = String(date.getHours()).padStart(2, "0");
    const mm = String(date.getMinutes()).padStart(2, "0");
    return `${hh}:${mm}`;
  };

  // whenever from_time or duration changes, update to_time automatically
  useEffect(() => {
    if (newSlot.from_time && newSlot.duration) {
      const calculated = addMinutes(newSlot.from_time, newSlot.duration);
      setNewSlot((prev) => ({ ...prev, to_time: calculated }));
    }
  }, [newSlot.from_time, newSlot.duration]);

  const dayNames = {
    1: "Monday",
    2: "Tuesday",
    3: "Wednesday",
    4: "Thursday",
    5: "Friday",
    6: "Saturday",
    0: "Sunday",
  };

  // ✅ Fetch Packages by Experience ID
  const fetchPackages = async () => {
    try {
      const expId = experienceId || updateexperienceId;
      if (!expId) return;

      const res = await axios.get(
        `${process.env.REACT_APP_API_BASE}/host/get-packages/${expId}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      if (res.data?.status && Array.isArray(res.data?.data)) {
        setPackages(res.data.data);
      } else {
        setPackages([]);
        toast.error("No packages found for this experience");
      }
    } catch (err) {
      console.error("Error fetching packages:", err);
    }
  };

  const fetchExperienceDates = async () => {
    try {
      const expId = experienceId || updateexperienceId;
      if (!expId) return;

      const res = await axios.get(
        `${process.env.REACT_APP_API_BASE}/host/get-host-experience/${expId}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (res.data?.status && res.data.data) {
        const data = res.data.data;

        // ✅ assuming API returns date strings like "2025-10-10"
        if (data.slot_from_date && data.slot_to_date) {
          setFromDate(data.slot_from_date);
          setToDate(data.slot_to_date);

          // Re-calculate allowed days immediately
          const start = new Date(data.slot_from_date);
          const end = new Date(data.slot_to_date);
          const days = [];
          while (start <= end) {
            const dayIndex = start.getDay(); // 0-6 (Sun-Sat)
            if (!days.includes(dayIndex)) days.push(dayIndex);
            start.setDate(start.getDate() + 1);
          }
          setAllowedDays(days);
        }
      }
    } catch (err) {
      console.error("Error fetching experience dates:", err);
    }
  };

  // ✅ Fetch Unavailable Slots for this experience
  const fetchUnavailableSlots = async () => {
    try {
      const expId = experienceId || updateexperienceId;
      if (!expId) return;

      const res = await axios.get(
        `${process.env.REACT_APP_API_BASE}/host/get-unavailable-slots?experience_id=${expId}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (res.data?.status && Array.isArray(res.data.data)) {
        const formatted = res.data.data.map((slot) => ({
          date: slot.date || "",
          from_time: slot.from_time?.slice(0, 5) || "",
          to_time: slot.to_time?.slice(0, 5) || "",
        }));
        setUnavailableSlots(formatted);
        
      } else {
        setUnavailableSlots([{ date: "", from_time: "", to_time: "" }]);
      }
    } catch (error) {
      console.error("Error fetching unavailable slots:", error);
    }
  };

  {/*const handleAddUnavailableSlot = () => {
  setShowUnavailablePopup(true);
};  */}


  // ✅ Call when experienceId changes
  useEffect(() => {
    if (experienceId || updateexperienceId) {
      fetchPackages();
    }
  }, [experienceId, updateexperienceId]);

 
  useEffect(() => {
    if (packages.length > 0) {
      const firstPkgId = packages[0].id;
      setActiveIndex(0);
      fetchHostSlots(firstPkgId);
    }
  }, [packages]);

  useEffect(() => {
    if (experienceId || updateexperienceId) {
      fetchExperienceDates();
    }
  }, [experienceId, updateexperienceId]);

  // Fetch unavailable slots when editing
  useEffect(() => {
    if (isEdit && (experienceId || updateexperienceId)) {
      fetchUnavailableSlots();
    }
  }, [isEdit, experienceId, updateexperienceId]);

  return (
    <div
      className={`frm_suport_als mng_bothss_li ${
        isSticky ? "manges_bx_areea" : ""
      }`}
    >
      <div className="row">
        <div
          className={`col-lg-4 col-sm-5 ${
            packages.length > 0 ? "active-class" : ""
          } ${isSticky ? "fixedss" : ""}`}
          id="sticy_fixedss"
        >
          {packages.length > 0 && (
            <div className="pakeges_ulli">
              {packages.map((pkg, index) => (
                <div className="tb_btnss" key={index}>
                  <button
                    type="button"
                    className={`al_sp_btn_blkss ${
                      activeIndex === index ? "actact" : ""
                    }`}
                    onClick={() => {
                      setActiveIndex(index);
                      fetchHostSlots(pkg.id); // ✅ Pass actual package ID
                    }}
                  >
                    {pkg.title || `Package ${index + 1}`}
                  </button>
                </div>
              ))}
            </div>
          )}
        </div>

        <div className="col-lg-6 col-sm-7">
          <form onSubmit={handleSubmit}>
            <div className="titlsss form_al_fildss">
              <h5>Set Schedule</h5>
              <div className="row">
                <div className="col-lg-6 col-6">
                  <div className="form-group">
                    <label>From</label>
                    <input
                      type="date"
                      className="form-control"
                      value={fromDate}
                      min={
                        isEdit
                          ? "" // ✅ allow back date when editing
                          : new Date().toISOString().split("T")[0] // 🚫 restrict in normal mode
                      }
                      max={
                        new Date(
                          new Date().setFullYear(new Date().getFullYear() + 1)
                        )
                          .toISOString()
                          .split("T")[0]
                      }
                      onChange={(e) => setFromDate(e.target.value)}
                    />
                  </div>
                </div>
                <div className="col-lg-6 col-6">
                  <div className="form-group">
                    <label>To</label>
                    <input
                      type="date"
                      className="form-control"
                      value={toDate}
                      min={new Date().toISOString().split("T")[0]}
                      max={
                        new Date(
                          new Date().setFullYear(new Date().getFullYear() + 1)
                        )
                          .toISOString()
                          .split("T")[0]
                      } // ✅ limit up to 1 year ahead
                      onChange={(e) => setToDate(e.target.value)}
                    />
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-lg-12 col-12">
                  <div className="form-group">
                    <label>No. of Pax</label>
<div className="form-group">
  <input
    type="number"
    className="form-control"
    placeholder="No. of Pax"
    value={noOfGuest}
    // onChange={(e) => setNoOfGuest(e.target.value)}
    onChange={(e) => {
    if (e.target.value.length <= 3) {
      setNoOfGuest(e.target.value);
    }
  }}
    min="1"
    max="999"
    maxLength={3}
  />
</div>

                      
                  </div>
                </div>
                
              </div>

              {/* <div className="slt bothsredoibtn mt-0 mb-1">
              <label className="label--checkbox rft">
                {" "}
                <input className="checkbox" type="checkbox" name="foo" /> I’d
                like to have weekly sessions{" "}
              </label>
            </div> */}

              <div className="form-group">
                <label>Choose Days</label>
                <div className="daychooes">
                  <ul>
                    {Object.entries(dayNames).map(([day, name]) => (
                      <li key={day}>
                        <div className="slt bothsredoibtn">
                          <label className="label--checkbox rft">
                            <input
                              className="checkbox"
                              type="checkbox"
                              checked={selectedDays.includes(Number(day))}
                              disabled={
                                allowedDays.length > 0 &&
                                !allowedDays.includes(Number(day))
                              }
                              onChange={() => handleDayToggle(Number(day))}
                            />
                            {name}
                          </label>
                        </div>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>

            <div className="titlsss form_al_fildss timesss">
              {selectedDays.length > 0 && <h5>Add Slots</h5>}

              <div className="ads_frm_areea bx_blankss">
                {selectedDays.map((day) => (
                  <div key={day} className="filllters">
                    <div className="disskses">
                      {dayNames[day]}

                      <div className="boths_mngess">
                        <span className="slots">{slots[day].length} Slots</span>
                        <div className="bothads">
                          <span className="btnss plss">
                            <button
                              type="button"
                              onClick={() => handleAddSlot(day)}
                            >
                              <img alt="" src="/images/pls_adss.png" />
                            </button>
                          </span>
                        </div>
                      </div>
                    </div>

                    {/* Existing Slots */}
                    {slots[day].map((slot, i) => (
                      <div key={i} className="mb-4">
                        {/* Duration Dropdown */}
                        <div className="form-group">
                          <label>Duration of slot</label>
                          <select
                            className="form-control"
                            value={slot.duration || 60}
                            onChange={(e) =>
                              handleSlotChange(
                                day,
                                i,
                                "duration",
                                e.target.value
                              )
                            }
                          >
                            <option value="">Choose duration</option>
                            <option value="30">30 min</option>
                            <option value="45">45 min</option>
                            <option value="60">60 min</option>
                            <option value="120">2 hr</option>
                            <option value="180">3 hr</option>
                            <option value="240">4 hr</option>
                            <option value="300">5 hr</option>
                            <option value="360">6 hr</option>
                            <option value="420">7 hr</option>
                            <option value="480">8 hr</option>
                            <option value="540">9 hr</option>
                            <option value="600">10 hr</option>
                          </select>
                        </div>

                        {/* Times and Delete button */}
                        <div className="row mb_mangess">
                          <div className="col-lg-4 col-5">
                            <div className="form-group">
                              <input
                                type="time"
                                className="form-control time_sets"
                                value={slot.from_time || ""}
                                onChange={(e) =>
                                  handleSlotChange(
                                    day,
                                    i,
                                    "from_time",
                                    e.target.value
                                  )
                                }
                              />
                            </div>
                          </div>
                          <div className="col-lg-1 col-2 mb_view_hide">
                            <div className="tochange text-center">To</div>
                          </div>
                          <div className="col-lg-4 col-5">
                            <div className="form-group">
                              <input
                                type="time"
                                className="form-control"
                                value={slot.to_time || ""}
                                onChange={(e) =>
                                  handleSlotChange(
                                    day,
                                    i,
                                    "to_time",
                                    e.target.value
                                  )
                                }
                              />
                            </div>
                          </div>
                          <div className="col-lg-2 col-2">
                            <div className="form-group mn_plss_bothss">
                              {/* Agar ek se zyada slots hain to remove button dikhao */}
                              {slots[day].length > 1 && (
                                <button
                                  type="button"
                                  className="removess"
                                  onClick={() => handleRemoveSlot(day, i)}
                                >
                                  <img src="/images/delates.png" alt="remove" />
                                </button>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                ))}

                {/*--- Mark Unavailable Slots ---*/}
                {isEdit && (
                  <div className="titlsss form_al_fildss timesss mt-5">
                    <div className="ads_frm_areea bx_blankss">
                      <div className="filllters">
                        <div className="disskses bothss_mngs">
                          <h5>Mark Unavailable Slots</h5>
                          <div className="boths_mngess">
                            <div className="bothads">
                              <span className="btnss plss">
                                 <button
                                  type="button"
                                  onClick={handleAddUnavailableSlot}
                                >
                                  <img alt="" src="/images/pls_adss.png" />
                                </button>
                                {/*<button type="button" onClick={handleAddUnavailableSlot}>
  <img alt="" src="/images/pls_adss.png" />
</button> */}

                              </span>
                            </div>
                          </div>
                        </div>

                        {unavailableSlots.map((slot, index) => (
                          <div className="main_areea" key={index}>
                            <div className="row mb_mangess">
                              <div className="col-lg-12">
                                <div className="form-group">
                                  <label>Slot Date</label>
                                  <input
                                    className="form-control"
                                    type="date"
                                    value={slot.date}
                                    onChange={(e) =>
                                      handleUnavailableSlotChange(
                                        index,
                                        "date",
                                        e.target.value
                                      )
                                    }
                                  />
                                </div>
                              </div>

                              <div className="col-lg-5 col-5">
                                <div className="form-group">
                                  <input
                                    className="form-control time_sets"
                                    type="time"
                                    value={slot.from_time}
                                    onChange={(e) =>
                                      handleUnavailableSlotChange(
                                        index,
                                        "from_time",
                                        e.target.value
                                      )
                                    }
                                  />
                                </div>
                              </div>

                              <div className="col-lg-5 col-5">
                                <div className="form-group">
                                  <input
                                    className="form-control"
                                    type="time"
                                    value={slot.to_time}
                                    onChange={(e) =>
                                      handleUnavailableSlotChange(
                                        index,
                                        "to_time",
                                        e.target.value
                                      )
                                    }
                                  />
                                </div>
                              </div>

                              <div className="col-lg-2 col-2">
                                <div className="form-group mn_plss_bothss">
                                  <button
                                    type="button"
                                    className="removess"
                                    onClick={() =>
                                      handleRemoveUnavailableSlot(index)
                                    }
                                  >
                                    <img
                                      alt="remove"
                                      src="/images/delates.png"
                                    />
                                  </button>
                                </div>
                              </div>

                              <div className="col-lg-12">
                                <span className="btm_datas">
                                  *Once you mark your unavailability, users will
                                  be notified
                                </span>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                )}

                {/*--- End Mark Unavailable Slots ---*/}

                <div className="form-group mt-1 text-center">
                  <button
                    type="button"
                    className="btn_allls over mr-0"
                    onClick={handleUpdatePackage}
                    disabled={loading}
                  >
                    {/* {loading ? "Updating..." : "Update"} */}
                    {loading
                      ? isEdit
                        ? "Updating..."
                        : "Saving..."
                      : isEdit
                      ? "Update"
                      : "Save"}
                  </button>
                </div>
              </div>

              <div className="form-group both">
                <button
                  type="button"
                  className="btn_allls over"
                  value=""
                  onClick={onBack}
                >
                  Back
                </button>
                <button
                  type="submit"
                  className="btn_allls"
                  // disabled={
                  //   loadingSubmit ||
                  //   loading ||
                  //   packages.length === 0 ||
                  //   completedPackages.length < packages.length
                  // }
                >
                  {/* {loadingSubmit ? "Saving..." : "Submit"} */}
                  {loadingSubmit ? (
  <>
    <span className="spinner"></span>
    
  </>
) : (
  "Submit"
)}
                </button>
              </div>
            </div>
          </form>
        </div>

        {showSuccessPopup && (
          <Success
            message="Your address and slots have been saved successfully!"
            onClose={() => {
              setShowSuccessPopup(false);
              navigate("/listing"); // redirect after closing popup
            }}
          />
        )}

        <UnavailableSlotPopup
  isOpen={showUnavailablePopup}
  onClose={() => setShowUnavailablePopup(false)}
  
/>

      </div>
    </div>
  );
}

export default ScheduleLocation;
